import type { CompanyInformationFormUpdate } from '@features/invoicingSettings/types/companyInformationFormUpdate'

import type { MissingCompanyDetailsForm } from '../../../types/missingComplianceDetails/missingCompanyDetailsForm'

interface GetCompanyFormInformationUpdateOptions {
  isPaymentInfoEditable: boolean
}

export const getCompanyFormInformationUpdate = (
  form: MissingCompanyDetailsForm,
  options: GetCompanyFormInformationUpdateOptions,
): CompanyInformationFormUpdate => {
  const { isPaymentInfoEditable } = options

  return {
    addressLine2: form.addressLine2,
    companyAddress: form.companyAddress,
    companyCity: form.companyCity,
    companyName: form.companyName,
    companyZipCode: form.companyZipCode,
    isSiretPendingAssignment: form.isSiretPendingAssignment,
    isVatExempted: form.isVatExempted,
    legalStatusCustom: form.legalStatusCustom,
    legalStatusOption: form.legalStatus,
    // Hidden IBAN fields hold the snapshot taken when the form was reset, which can be older than the saved settings.
    ...(isPaymentInfoEditable && {
      paymentMethods: {
        bank: form.bank,
        iban: form.iban,
        swift: form.swift,
      },
    }),
    registrationNo: form.registrationNo,
    sharedCapital: form.sharedCapital,
    vatNo: form.vatNo,
  }
}
